// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #9b9a9a;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #777676;
}

.formContainer {
  background-color: #ffffff;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.formContainer .formWrapper {
  background-color: white;
  padding: 20px 60px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
.formContainer .formWrapper .logo {
  color: #5d5b8d;
  font-weight: bold;
  font-size: 24px;
}
.formContainer .formWrapper .title {
  color: #5d5b8d;
  font-size: 12px;
}
.formContainer .formWrapper form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.formContainer .formWrapper form input {
  padding: 15px;
  border: none;
  width: 250px;
  border-bottom: 1px solid #a7bcff;
}
.formContainer .formWrapper form input::placeholder {
  color: rgb(175, 175, 175);
}
.formContainer .formWrapper form button {
  background-color: #ffffff;
  color: white;
  padding: 10px;
  font-weight: bold;
  border: none;
  cursor: pointer;
}
.formContainer .formWrapper form label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #8da4f1;
  font-size: 12px;
  cursor: pointer;
}
.formContainer .formWrapper form label img {
  width: 32px;
}
.formContainer .formWrapper p {
  color: #5d5b8d;
  font-size: 12px;
  margin-top: 10px;
}

.home {
  background-color: #ffffff;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home .containerChat {
  width: 85vw;
  height: 100vh;
  margin-left: 85px;
  display: flex;
  overflow: hidden;
}
@media screen and (max-width: 768px) {
  .home .containerChat {
    width: 98%;
    margin-left: 0px;
  }
}
@media screen and (max-width: 480px) {
  .home .containerChat {
    margin-left: 0px;
  }
}
.home .containerChat .sidebarChat:before {
  content: none;
}
.home .containerChat .sidebarChat {
  flex: 1 1;
  background: #ffffff;
  position: relative;
  margin-left: 0px;
  border: 1px solid #c7c6c6;
  margin-top: 85px;
  border-radius: 10px;
  margin-bottom: 20px;
}
@media screen and (max-width: 480px) {
  .home .containerChat .sidebarChat {
    width: 80px;
  }
}
@media screen and (max-width: 1024px) {
  .home .containerChat .sidebarChat {
    margin-bottom: 25%;
  }
}
@media screen and (max-width: 768px) {
  .home .containerChat .sidebarChat {
    margin-bottom: 63%;
  }
}
.home .containerChat .sidebarChat .navbarChat {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  height: 50px;
  padding: 10px;
  justify-content: space-between;
  color: #000000;
  border-radius: 10px 10px 0px 0px;
}
.home .containerChat .sidebarChat .navbarChat .logo {
  font-weight: bold;
}
@media screen and (max-width: 768px) {
  .home .containerChat .sidebarChat .navbarChat .logo {
    display: none;
  }
}
.home .containerChat .sidebarChat .navbarChat .logo:after {
  content: none;
}
.home .containerChat .sidebarChat .navbarChat .user:after {
  content: none;
}
.home .containerChat .sidebarChat .navbarChat .user {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
.home .containerChat .sidebarChat .navbarChat .user img {
  background-color: #ddddf7;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  object-fit: cover;
}
.home .containerChat .sidebarChat .navbarChat .user button {
  background-color: #5d5b8d;
  color: #000000;
  font-size: 10px;
  border: none;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .home .containerChat .sidebarChat .navbarChat .user button {
    position: absolute;
    bottom: 10px;
  }
}
.home .containerChat .sidebarChat .search {
  border-bottom: 1px solid gray;
}
.home .containerChat .sidebarChat .search .searchForm {
  padding: 10px;
}
.home .containerChat .sidebarChat .search .searchForm input {
  background-color: transparent;
  border: none;
  color: white;
  outline: none;
}
.home .containerChat .sidebarChat .search .searchForm input::placeholder {
  color: lightgray;
}
.home .containerChat .sidebarChat .searchUser {
  margin: 5px 15px;
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 480px) {
  .home .containerChat .sidebarChat .searchUser {
    display: block;
  }
}
.home .containerChat .sidebarChat .searchUser input {
  background: lightgrey;
  border-radius: 2px;
  border: none;
  padding: 5px;
}
@media screen and (max-width: 480px) {
  .home .containerChat .sidebarChat .searchUser input {
    width: 61px;
  }
}
.home .containerChat .sidebarChat .searchUser input:focus {
  outline: none;
}
.home .containerChat .sidebarChat .chats {
  height: calc(100vh - 200px);
  border-radius: 10px;
  overflow: auto;
}
@media screen and (max-width: 1024px) {
  .home .containerChat .sidebarChat .chats {
    height: 47vh;
  }
}
@media screen and (max-width: 768px) {
  .home .containerChat .sidebarChat .chats {
    height: 36vh;
  }
}
.home .containerChat .sidebarChat .chats .userChats {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(223, 222, 222);
  cursor: pointer;
}
.home .containerChat .sidebarChat .chats .userChats:hover {
  background-color: rgba(233, 233, 233, 0.9294117647);
}
.home .containerChat .sidebarChat .chats .userChats .removeUser img {
  height: 25px;
  width: 25px;
  margin-top: 20px;
  cursor: pointer;
}
.home .containerChat .sidebarChat .chats .userChats .userChat {
  position: relative;
  overflow-x: hidden;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000000;
  cursor: pointer;
  width: 100%;
}
.home .containerChat .sidebarChat .chats .userChats .userChat .NameImg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  background: #3dcfcf;
}
.home .containerChat .sidebarChat .chats .userChats .userChat .userChatInfo {
  width: 70%;
  word-wrap: break-word;
}
@media screen and (max-width: 480px) {
  .home .containerChat .sidebarChat .chats .userChats .userChat .userChatInfo {
    display: none;
  }
}
.home .containerChat .sidebarChat .chats .userChats .userChat .userChatInfo span {
  font-size: 16px;
  font-weight: 300;
}
.home .containerChat .sidebarChat .chats .userChats .userChat .userChatInfo p {
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home .containerChat .chat {
  flex: 3 1;
  margin-left: 10px;
  border-radius: 10px;
}
.home .containerChat .chat .chatInfo {
  height: 50px;
  background-color: #ffffff;
  border: 1px solid #ebe4e4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  color: lightgray;
  margin-top: 82px;
  border-radius: 10px 10px 0px 0px;
}
.home .containerChat .chat .chatInfo img {
  width: 25px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.home .containerChat .chat .chatIcons {
  display: flex;
  gap: 10px;
}
.home .containerChat .chat .chatIcons img {
  height: 25px;
  cursor: pointer;
}
.home .containerChat .chat .messages {
  background-color: rgba(233, 233, 233, 0.9294117647);
  padding: 10px;
  height: calc(100vh - 200px);
  overflow-y: auto;
  border-left: 1px solid #ebe4e4;
  border-right: 1px solid #ebe4e4;
}
@media screen and (max-width: 480px) {
  .home .containerChat .chat .messages {
    height: 45vh;
  }
}
@media screen and (max-width: 1024px) {
  .home .containerChat .chat .messages {
    height: 48vh;
  }
}
@media screen and (max-width: 768px) {
  .home .containerChat .chat .messages {
    height: 37vh;
  }
}
.home .containerChat .chat .messages .message {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  overflow-x: hidden;
}
.home .containerChat .chat .messages .message .messageInfo {
  display: flex;
  flex-direction: column;
  color: gray;
  font-weight: 300;
}
.home .containerChat .chat .messages .message .messageInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.home .containerChat .chat .messages .message .messageContent {
  max-width: 60%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.home .containerChat .chat .messages .message .messageContent p {
  background-color: white;
  padding: 7px;
  border-radius: 9px 8px 12px 0px;
  max-width: max-content;
  word-break: break-word;
}
.home .containerChat .chat .messages .message .messageContent img {
  width: 50%;
}
.home .containerChat .chat .messages .message.owner {
  flex-direction: row-reverse;
}
.home .containerChat .chat .messages .message.owner .messageContent {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.home .containerChat .chat .messages .message.owner .messageContent p {
  background-color: #1d8864;
  color: white;
  max-width: 100%;
  word-wrap: break-word;
  border-radius: 9px 8px 0px 12px;
}
.home .containerChat .chat .input {
  height: 50px;
  border-left: 1px solid #ebe4e4;
  border-top: 1px solid #ccc9c9;
  border-bottom: 1px solid #ebe4e4;
  background-color: white;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0px 0px 10px 10px;
}
.home .containerChat .chat .input label {
  cursor: pointer;
  width: "30px";
}
.home .containerChat .chat .input input {
  width: 100%;
  border: none;
  outline: none;
  color: #2f2d52;
  font-size: 18px;
}
.home .containerChat .chat .input input::placeholder {
  color: lightgray;
}
.home .containerChat .chat .input .send {
  display: flex;
  align-items: center;
  gap: 10px;
}
.home .containerChat .chat .input .send img {
  height: 20px;
  cursor: pointer;
}
.home .containerChat .chat .input .send button {
  border: none;
  margin: 10px;
  padding: 5px 5px;
  color: white;
  background-color: #1d8864;
  cursor: pointer;
  border-radius: 10px;
  height: 30px;
  width: 70px;
}

.template-radio {
  margin-left: 20px;
}

.template-radio-p {
  margin-left: 30px;
}

.temp {
  cursor: "pointer";
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss"],"names":[],"mappings":"AAoBA,UAAA;AACA;EACE,UAAA;AAnBF;;AAsBA,UAAA;AACA;EACE,8BAAA;EACA,mBAAA;AAnBF;;AAsBA,WAAA;AACA;EACE,mBAAA;EAEA,mBAAA;AApBF;;AAuBA,oBAAA;AACA;EACE,mBAAA;AApBF;;AAsBA;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnBF;AAqBE;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAnBN;AAsBI;EACE,cAAA;EACA,eAAA;AApBN;AAuBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArBN;AAuBM;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;AArBR;AAsBQ;EACE,yBAAA;AApBV;AAwBM;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAtBR;AAyBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAvBR;AAyBQ;EACE,WAAA;AAvBV;AA2BI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAzBN;;AA8BA;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3BF;AA6BE;EAGE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AA7BJ;AA7FE;EAmHA;IASI,UAAA;IACA,gBAAA;EA3BJ;AACF;AAxGE;EAwHA;IAaI,gBAAA;EAzBJ;AACF;AA0BI;EACE,aAAA;AAxBN;AA0BI;EAWE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAnCN;AA1HE;EA0IE;IAEI,WAAA;EAdN;AACF;AArHE;EAgIE;IAKI,kBAAA;EAZN;AACF;AA/HE;EAqIE;IAQI,kBAAA;EAVN;AACF;AAsBM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;EACA,gCAAA;AApBR;AAsBQ;EACE,iBAAA;AApBV;AAjJE;EAoKM;IAGI,aAAA;EAlBV;AACF;AAoBQ;EACE,aAAA;AAlBV;AAoBQ;EACE,aAAA;AAlBV;AAoBQ;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAlBV;AAoBU;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAlBZ;AAqBU;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAnBZ;AA/KE;EA6LQ;IAOI,kBAAA;IACA,YAAA;EAjBZ;AACF;AAqBM;EACE,6BAAA;AAnBR;AAqBQ;EACE,aAAA;AAnBV;AAqBU;EACE,6BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AAnBZ;AAqBY;EACE,gBAAA;AAnBd;AAwBM;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AAtBR;AA9ME;EAiOI;IAKI,cAAA;EApBR;AACF;AAqBQ;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAnBV;AAzNE;EAwOM;IAMI,WAAA;EAjBV;AACF;AAoBQ;EACE,aAAA;AAlBV;AAqBM;EASE,2BAAA;EACA,mBAAA;EACA,cAAA;AA3BR;AA5NE;EA4OI;IAEI,YAAA;EAdR;AACF;AAtOE;EAiPI;IAKI,YAAA;EAZR;AACF;AAkBQ;EACE,aAAA;EACA,8BAAA;EAIA,2CAAA;EACA,eAAA;AAnBV;AAeU;EACE,mDAAA;AAbZ;AAmBY;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAjBd;AAuBU;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AArBZ;AAsBY;EACK,WAAA;EACH,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AApBd;AA6BY;EAIE,UAAA;EACA,qBAAA;AA9Bd;AArRE;EA8SU;IAEI,aAAA;EAvBd;AACF;AA0Bc;EACE,eAAA;EACA,gBAAA;AAxBhB;AA0Bc;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAxBhB;AAgCI;EACE,SAAA;EACA,iBAAA;EAEA,mBAAA;AA/BN;AAiCM;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AA/BR;AAiCQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA/BV;AAmCM;EACE,aAAA;EACA,SAAA;AAjCR;AAmCQ;EACE,YAAA;EACA,eAAA;AAjCV;AAqCM;EACE,mDAAA;EACA,aAAA;EAEA,2BAAA;EAcA,gBAAA;EACA,8BAAA;EACA,+BAAA;AAjDR;AA7UE;EA0WI;IAME,YAAA;EA/BN;AACF;AAxUE;EAgWI;IASU,YAAA;EA7Bd;AACF;AAlVE;EAqWI;IAYI,YAAA;EA3BR;AACF;AAoCQ;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAlCV;AAoCU;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAlCZ;AAoCY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAlCd;AAqCU;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EAEA,SAAA;AApCZ;AAsCY;EACE,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,sBAAA;EACD,sBAAA;AApCb;AAuCY;EACE,UAAA;AArCd;AAyCU;EACE,2BAAA;AAvCZ;AAyCY;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAvCd;AAwCc;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,+BAAA;AAtChB;AA6CM;EACE,YAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AA3CR;AA6CQ;EACE,eAAA;EACA,aAAA;AA3CV;AA6CQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA3CV;AA8CU;EACE,gBAAA;AA5CZ;AAgDQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9CV;AAiDU;EAEE,YAAA;EACA,eAAA;AAhDZ;AAmDU;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAjDZ;;AA0DE;EACE,iBAAA;AAvDJ;;AAyDA;EACE,iBAAA;AAtDF;;AAyDC;EAEC,iBAAA;AAvDF","sourcesContent":["@mixin mobile {\n  @media screen and (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media screen and (max-width: 768px) {\n    @content;\n  }\n}\n@mixin tabletH {\n  @media screen and (max-width: 1024px) {\n    @content;\n  }\n}\n@mixin laptop {\n  @media screen and (max-width: 1200px) {\n    @content;\n  }\n}\n/* width */\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey; \n  border-radius: 10px;\n}\n \n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #9b9a9a; \n\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #777676; \n}\n.formContainer {\n  background-color: #ffffff;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .formWrapper {\n    background-color: white;\n    padding: 20px 60px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n\n    .logo {\n      color: #5d5b8d;\n      font-weight: bold;\n      font-size: 24px;\n    }\n\n    .title {\n      color: #5d5b8d;\n      font-size: 12px;\n    }\n\n    form {\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n\n      input {\n        padding: 15px;\n        border: none;\n        width: 250px;\n        border-bottom: 1px solid #a7bcff;\n        &::placeholder {\n          color: rgb(175, 175, 175);\n        }\n      }\n\n      button {\n        background-color: #ffffff;\n        color: white;\n        padding: 10px;\n        font-weight: bold;\n        border: none;\n        cursor: pointer;\n      }\n\n      label {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        color: #8da4f1;\n        font-size: 12px;\n        cursor: pointer;\n\n        img {\n          width: 32px;\n        }\n      }\n    }\n    p {\n      color: #5d5b8d;\n      font-size: 12px;\n      margin-top: 10px;\n    }\n  }\n}\n\n.home {\n  background-color: #ffffff;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .containerChat {\n    // border: 1px solid white;\n    // border-radius: 10px;\n    width: 85vw;\n    height: 100vh;\n    margin-left: 85px;\n    display: flex;\n    overflow: hidden;\n    @include tablet {\n      width: 98%;\n      margin-left: 0px;\n    }\n    @include mobile() {\n      margin-left: 0px;\n    }\n    .sidebarChat:before {\n      content: none;\n    }\n    .sidebarChat {\n      @include mobile(){\n        width: 80px;\n      }\n      @include tabletH(){\n        margin-bottom: 25%;\n      }\n      @include tablet(){\n        margin-bottom: 63%;\n      }\n      \n      flex: 1;\n      background: #ffffff;\n      position: relative;\n      margin-left: 0px;\n      border: 1px solid #c7c6c6;\n\n      margin-top: 85px;\n      border-radius: 10px;\n      margin-bottom: 20px;\n\n      .navbarChat {\n        display: flex;\n        align-items: center;\n        background-color: #ffffff;\n        height: 50px;\n        padding: 10px;\n        justify-content: space-between;\n        color: #000000;\n        border-radius: 10px 10px 0px 0px;\n\n        .logo {\n          font-weight: bold;\n          @include tablet {\n            display: none;\n          }\n        }\n        .logo:after {\n          content: none;\n        }\n        .user:after {\n          content: none;\n        }\n        .user {\n          display: flex;\n          gap: 10px;\n          margin-top: 10px;\n\n          img {\n            background-color: #ddddf7;\n            height: 24px;\n            width: 24px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n\n          button {\n            background-color: #5d5b8d;\n            color: #000000;\n            font-size: 10px;\n            border: none;\n            cursor: pointer;\n            @include tablet {\n              position: absolute;\n              bottom: 10px;\n            }\n          }\n        }\n      }\n      .search {\n        border-bottom: 1px solid gray;\n\n        .searchForm {\n          padding: 10px;\n\n          input {\n            background-color: transparent;\n            border: none;\n            color: white;\n            outline: none;\n\n            &::placeholder {\n              color: lightgray;\n            }\n          }\n        }\n      }\n      .searchUser{\n        margin: 5px 15px ;\n        display: flex;\n        justify-content: space-between;\n        @include mobile(){\n          display: block;\n        }\n        input{\n          background: lightgrey;\n          border-radius: 2px;\n          border: none;\n          padding: 5px;\n          @include mobile(){\n            width: 61px;\n          }\n\n        }\n        input:focus{\n          outline: none;\n      }\n      }\n      .chats{\n        @include tabletH(){\n          height: 47vh;\n        }\n        @include tablet(){\n          height: 36vh;\n        }\n       \n        // height: 76vh;\n        height: calc(100vh - 200px);\n        border-radius: 10px;\n        overflow: auto;\n        .userChats {\n          display: flex;\n          justify-content: space-between;\n          &:hover {\n            background-color: #e9e9e9ed;\n          }\n          border-bottom: 1px solid rgb(223, 222, 222);\n          cursor: pointer;\n          .removeUser {\n            \n            img {\n              height: 25px;\n              width: 25px;\n              margin-top: 20px;\n              cursor: pointer;\n            }\n          \n      \n        }\n\n          .userChat {\n            position: relative;\n            overflow-x: hidden;\n            padding: 10px;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            color: #000000;\n            cursor: pointer;\n            width: 100%;\n            .NameImg{\n                 width: 50px;\n              height: 50px;\n              border-radius: 50%;\n              object-fit: cover;\n              background: #3dcfcf;\n            }\n            // img {\n            //   width: 50px;\n            //   height: 50px;\n            //   border-radius: 50%;\n            //   object-fit: cover;\n            // }\n\n            .userChatInfo {\n              @include mobile(){\n                display: none;\n              }\n              width: 70%;\n              word-wrap: break-word;\n              span {\n                font-size: 16px;\n                font-weight: 300;\n              }\n              p {\n                font-size: 12px;\n                color: #000000;\n                white-space: nowrap; \n                width: 100px; \n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n            }\n          }\n        \n        }\n      }\n    }\n    .chat {\n      flex: 3;\n      margin-left: 10px;\n    \n      border-radius: 10px;\n\n      .chatInfo {\n        height: 50px;\n        background-color: #ffffff;\n        border: 1px solid #ebe4e4;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 10px;\n        color: lightgray;\n        margin-top: 82px;\n        border-radius: 10px 10px 0px 0px;\n\n        img {\n          width: 25px;\n          height: 40px;\n          border-radius: 50%;\n          object-fit: cover;\n        }\n      }\n\n      .chatIcons {\n        display: flex;\n        gap: 10px;\n\n        img {\n          height: 25px;\n          cursor: pointer;\n        }\n      }\n\n      .messages {\n        background-color: #e9e9e9ed;\n        padding: 10px;\n\n        height: calc(100vh - 200px);\n       @include mobile(){\n        height:45vh;\n              }\n              @include tabletH(){\n                height: 48vh;\n              }\n        @include tablet(){\n          height: 37vh;\n        }\n\n        \n\n        // height: calc(100% - 200px);\n        overflow-y: auto;\n        border-left: 1px solid #ebe4e4;\n        border-right: 1px solid #ebe4e4;\n\n        .message {\n          display: flex;\n          gap: 20px;\n          margin-bottom: 20px;\n          overflow-x: hidden;\n\n          .messageInfo {\n            display: flex;\n            flex-direction: column;\n            color: gray;\n            font-weight: 300;\n\n            img {\n              width: 40px;\n              height: 40px;\n              border-radius: 50%;\n              object-fit: cover;\n            }\n          }\n          .messageContent {\n            max-width: 60%;\n            display: flex;\n            justify-content:space-between;\n           // flex-direction: column;\n            gap: 10px;\n\n            p {\n              background-color: white;\n              padding: 7px;\n              border-radius: 9px 8px 12px 0px;\n              max-width: max-content;    \t   \n\t            word-break: break-word;\n            }\n\n            img {\n              width: 50%;\n            }\n          }\n\n          &.owner {\n            flex-direction: row-reverse;\n\n            .messageContent {\n              display: flex;\n              justify-content:space-between;\n              align-items: flex-end;\n              p {\n                background-color: #1d8864;\n                color: white;\n                max-width: 100%;\n                word-wrap:break-word;\n                border-radius: 9px 8px 0px 12px;\n              }\n            }\n          }\n        }\n      }\n\n      .input {\n        height: 50px;\n        border-left: 1px solid #ebe4e4;\n        border-top: 1px solid #ccc9c9;\n        border-bottom: 1px solid #ebe4e4;\n        background-color: white;\n        padding: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-radius: 0px 0px 10px 10px;\n\n        label {\n          cursor: pointer;\n          width: \"30px\" \n       }\n        input {\n          width: 100%;\n          border: none;\n          outline: none;\n          color: #2f2d52;\n          font-size: 18px;\n         \n\n          &::placeholder {\n            color: lightgray;\n          }\n        }\n\n        .send {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          \n\n          img {\n            //position: fixed;\n            height: 20px;\n            cursor: pointer;\n          }\n\n          button {\n            border: none;\n            margin: 10px;\n            padding: 5px 5px;\n            color: white;\n            background-color: #1d8864;\n            cursor: pointer;\n            border-radius: 10px;\n            height: 30px;\n            width: 70px;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n  .template-radio{\n    margin-left: 20px;\n} \n.template-radio-p{\n  margin-left: 30px;\n} \n\n .temp{\n\n  cursor: \"pointer\";\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
